import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import assessmentFactor from './assessmentFactor';
import directive from './maturity-domain.directive';
import controller from './maturity-domain.controller';

export default angular.module('app.components.advisory.ecat.maturityDomain', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  assessmentFactor,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('ecatMaturityDomain', directive)
  .controller('ECATMaturityDomainController', controller)
  .name;

console.log('app.components.advisory.ecat.maturityDomain created');
